export class Version
{
	public static readonly version: string = "4.20.1";
	public static readonly majorVersion: string = "4.20";
	public static readonly apiName: string = "grunt.api";
	public static readonly apiUrl: string = "https://dotapi.gg/";
}